import React, { useEffect } from "react";
import * as motion from "motion/react-client";
import { useDispatch, useSelector } from "react-redux";
import { playbackCamera, playbackSelectedCamera } from "slice/playbackSlice";
import { getVideoDetails } from "slice/videoResponseSlice";
import { getvideoList } from "slice/videoSlice";
import { LoadingLive } from "Component/LoadingModal/LoadingLive";
import NoVideoDisplay from "Component/EmptyData/NoVideoDisplay";

export const Videos = () => {
  const dispatch = useDispatch();
  const { datavideoList, isLoadingvideoList } = useSelector(
    (state) => state.videoList.videoList
  );

  const handleSeclectedCamera = (video) => {
    dispatch(playbackSelectedCamera(video));
    dispatch(playbackCamera(video));
  };

  useEffect(() => {
    dispatch(getVideoDetails());
    dispatch(getvideoList());
  }, [dispatch]);

  if (isLoadingvideoList) {
    return (
      <div className="w-full overflow-hidden">
        {isLoadingvideoList && <LoadingLive />}
      </div>
    );
  }

  if (datavideoList.length === 0) {
    return (
      <div className="">
        <NoVideoDisplay />
      </div>
    );
  }
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-white overflow-scroll "
      style={{ maxHeight: "80vh" }}
    >
      {datavideoList?.map((video, index) => (
        <motion.div
          key={video.id}
          initial={{ opacity: 0, y: 100 }} // Muncul dari bawah
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: (index % 3) * 0.1 }}
          className={`relative bg-black ${video?.processStatus === "COMPLETED" ? "cursor-pointer" : ""}  hover:bg-slate-700`}
          // onClick={() => handleSeclectedCamera(video)}
          onClick={() => {
            if (video?.processStatus === "COMPLETED") {
              handleSeclectedCamera(video);
            }
            // dispatch(cleardataIpCamList([]));
          }}
        >
          {/* {console.log(`https://facereco.grit.id:9004/${video?.videoPath}/${video?.videoPath}.mp4`)} */}
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 z-10 w-full border-t-2 border-mo-button"></div>
            <div className="absolute bottom-0 z-10 w-full border-b-2 border-mo-button"></div>
            <div className="absolute left-0 z-10 h-full border-l-2 border-mo-button"></div>
            <div className="absolute right-0 z-10 h-full border-r-2 border-mo-button"></div>
          </div>
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 left-0 z-20 w-4 h-4 border-t-4 border-l-4 border-mo-text"></div>
            <div className="absolute top-0 right-0 z-20 w-4 h-4 border-t-4 border-r-4 border-mo-text"></div>
            <div className="absolute bottom-0 left-0 z-20 w-4 h-4 border-b-4 border-l-4 border-mo-text"></div>
            <div className="absolute bottom-0 right-0 z-20 w-4 h-4 border-b-4 border-r-4 border-mo-text"></div>
          </div>
          {/* Video Content */}
          <div className="flex flex-col p-4 gap-4 h-[300px]">
            {/* Header */}
            <div className="flex justify-between mb-2">
              <div className="flex items-center gap-2">
                <img src="/asset/logoVideo.svg" width={20} alt="Icon" />
                <div>{video.nama_video}</div>
              </div>
              {/* <div className="flex gap-2">
                <img
                  src="/asset/littleBox.svg"
                  width={20}
                  alt="Settings Icon"
                />
              </div> */}
            </div>

            {/* Video Section */}
            <div className="flex flex-col items-center justify-center grow relative">
              {video.isActive ? (
                <div className="relative w-full h-full">
                  {video.isActive && (
                    <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-70 text-white">
                      {video?.processStatus === "COMPLETED" ? (
                        <video
                          id={`video-${video.id}`}
                          autoPlay
                          playsInline
                          loop
                          muted
                          src={`https://facereco.grit.id:9004/${video?.videoPath}/${video?.videoPath}.mp4`}
                          // src={video?.linkVideo}
                          crossOrigin="anonymous"
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "contain",
                          }}
                          // poster={`https://facereco.grit.id:9004/${video?.videoPath}/thumbnail.jpg`}
                          className="absolute "
                        >
                          {/* <source
                            src={`https://facereco.grit.id:9004/${video?.videoPath}/${video?.videoPath}.mp4`}
                            type="video/mp4"
                          /> */}
                        </video>
                      ) : video?.processStatus === "FAILED" ? (
                        <img
                          src="/asset/backgroundVideo.png"
                          alt="Background"
                          className="w-full h-full object-fill"
                        />
                      ) : (
                        <img
                          src="/asset/loadingBackroundVideo.png"
                          alt="Background"
                          className="w-full h-full object-fill"
                        />
                      )}

                      <div className="absolute flex flex-col items-center justify-center">
                        <div>
                          {video?.processStatus === "COMPLETED" ? (
                            ""
                          ) : video?.processStatus === "FAILED" ? (
                            <img
                              src="/asset/Disconnected.svg"
                              alt="Disconnected"
                              className="mb-4 w-15 h-15 "
                            />
                          ) : (
                            <img
                              src="/asset/SpinnerTranparant2.gif"
                              alt="Disconnected"
                              className="mb-4 w-10 h-10 "
                            />
                          )}
                        </div>
                        <h1 className="font-bold">
                          {video?.processStatus === "COMPLETED"
                            ? ``
                            : video?.processStatus === "FAILED"
                              ? ""
                              : `Sedang diproses...`}
                        </h1>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center w-full h-full bg-stone-200 text-black">
                  <div className="font-semibold">No cam selected.</div>
                  <p className="font-light mt-2 text-sm">
                    Select camera to start monitoring.
                  </p>
                </div>
              )}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};
